import { createShare } from '@/services/api';
import sleep from '@/utils/sleep';
import {
  CREATE_POST_IN_PROGRESS,
  SUBMIT_POST_IN_PROGRESS,
  UPDATE_POST_IN_PROGRESS
} from '../action-types';
import {
  POST_IN_PROGRESS_CREATED,
  POST_IN_PROGRESS_SUBMITTED,
  POST_IN_PROGRESS_UPDATED
} from '../mutation-types';

export default function createPostModule() {
  return {
    state: () => ({
      inProgress: {}
    }),

    getters: {
      postInProgress: state => state.inProgress
    },

    mutations: {
      [POST_IN_PROGRESS_CREATED]: (state, options) => {
        state.inProgress = options;
      },

      [POST_IN_PROGRESS_UPDATED]: (state, options) => {
        Object.assign(state.inProgress, options);
      },

      [POST_IN_PROGRESS_SUBMITTED]: (state) => {
        state.inProgress = {};
      }
    },

    actions: {
      [CREATE_POST_IN_PROGRESS]: (context, options) => {
        context.commit(POST_IN_PROGRESS_CREATED, options);
      },

      [SUBMIT_POST_IN_PROGRESS]: async (context, options) => {
        await createShare(options);
        await sleep(1000);
        context.commit(POST_IN_PROGRESS_SUBMITTED);
      },

      [UPDATE_POST_IN_PROGRESS]: (context, options) => {
        context.commit(POST_IN_PROGRESS_UPDATED, options);
      }
    }
  };
}

export const state = {
  inProgress: {}
};

export const getters = {
  postInProgress: state => state.inProgress
};

export const actions = {
  [CREATE_POST_IN_PROGRESS]: (context, options) => {
    context.commit(POST_IN_PROGRESS_CREATED, options);
  },

  [SUBMIT_POST_IN_PROGRESS]: async (context, options) => {
    await createShare(options);
    await sleep(1000);
    context.commit(POST_IN_PROGRESS_SUBMITTED);
  },

  [UPDATE_POST_IN_PROGRESS]: (context, options) => {
    context.commit(POST_IN_PROGRESS_UPDATED, options);
  }
};

export const mutations = {
  [POST_IN_PROGRESS_CREATED]: (state, options) => {
    state.inProgress = options;
  },

  [POST_IN_PROGRESS_UPDATED]: (state, options) => {
    Object.assign(state.inProgress, options);
  },

  [POST_IN_PROGRESS_SUBMITTED]: (state) => {
    state.inProgress = {};
  }
};
